var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkingIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94414 22.1064C7.94414 22.366 7.73174 22.5784 7.47213 22.5784C7.21251 22.5784 7.00011 22.366 7.00011 22.1064C6.99381 19.9477 7.53033 17.8647 8.51053 16.0176C9.49545 14.1594 10.9288 12.542 12.7051 11.3385C12.9175 11.1906 13.2117 11.2504 13.3596 11.4628C13.5075 11.6752 13.4477 11.9694 13.2353 12.1173C11.5896 13.2328 10.2617 14.7306 9.34755 16.4597C8.43973 18.1762 7.94411 20.1114 7.94411 22.1111L7.94414 22.1064Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.752 12.1123C26.5396 11.9644 26.4814 11.6765 26.6277 11.4578C26.7756 11.2454 27.0635 11.1871 27.2823 11.3335C29.0696 12.5434 30.4919 14.1592 31.4703 16.0126C32.4553 17.8707 32.9871 19.9648 32.9808 22.1127C32.9808 22.3723 32.7684 22.5847 32.5088 22.5847C32.2492 22.5847 32.0367 22.3723 32.0367 22.1127C32.043 20.1239 31.5474 18.1777 30.6333 16.4548C29.7255 14.7383 28.4038 13.2389 26.7518 12.1185L26.752 12.1123Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7732 32.6491C26.0029 32.5248 26.2861 32.6082 26.4104 32.8379C26.5347 33.0676 26.4513 33.3508 26.2216 33.4751C24.3273 34.5135 22.2394 35.039 20.1501 35.0626C18.0433 35.0862 15.9382 34.6032 14.0315 33.623C13.8017 33.505 13.7073 33.2218 13.8316 32.9858C13.9496 32.7561 14.2328 32.6617 14.4688 32.786C16.2388 33.7001 18.1914 34.1485 20.144 34.1249C22.0792 34.1013 24.0207 33.612 25.772 32.6506L25.7732 32.6491Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.613 7.11049C22.613 8.27604 21.6682 9.22085 20.5026 9.22085C19.3371 9.22085 18.3923 8.27604 18.3923 7.11049C18.3923 5.94493 19.3371 5.00012 20.5026 5.00012C21.6682 5.00012 22.613 5.94493 22.613 7.11049",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0591 16.514C16.0591 13.3044 18.0477 10.7018 20.5024 10.7018C22.9562 10.7018 24.9457 13.3045 24.9457 16.514",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8133 16.4629H24.9239",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9075 20.6575C29.9075 21.823 28.9627 22.7678 27.7972 22.7678C26.6316 22.7678 25.6868 21.823 25.6868 20.6575C25.6868 19.4919 26.6316 18.5471 27.7972 18.5471C28.9627 18.5471 29.9075 19.4919 29.9075 20.6575",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3536 30.061C23.3536 26.8513 25.3422 24.2487 27.7969 24.2487C30.2507 24.2487 32.2402 26.8515 32.2402 30.061",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1078 30.0099H32.2184",
    stroke: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2765 20.6575C14.2765 21.823 13.3317 22.7678 12.1662 22.7678C11.0006 22.7678 10.0558 21.823 10.0558 20.6575C10.0558 19.4919 11.0006 18.5471 12.1662 18.5471C13.3317 18.5471 14.2765 19.4919 14.2765 20.6575",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7226 30.061C7.7226 26.8513 9.71126 24.2487 12.1659 24.2487C14.6197 24.2487 16.6092 26.8515 16.6092 30.061",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47684 30.0099H16.5875",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkingIconWhite);
export default __webpack_public_path__ + "static/media/Networking_icon_white.4bf0f149f4e96d7688dd507b9e5005a4.svg";
export { ForwardRef as ReactComponent };